// extracted by mini-css-extract-plugin
module.exports = {"collaspible":"collapsible-list_collaspible__UolEO","icon":"collapsible-list_icon__TTNlh","active":"collapsible-list_active__WRTEr"};